$('.trade-account-next').click(function (e) {
    if (IsContactFormValid()) {
        var formDataArray = $('#trade-account-form').serializeArray();
        contactDetailsJSON = serializeObject(formDataArray);
        nextButtonLogic(".trade-account-next");
    } else {
        headingCheck();
        getTabHeightTradeJs();
    }
    return false;
});

function formPlacement() {
    if ($('.keep-updated-block').length > 0) {
        var countY = $('.keep-updated-block').outerHeight();
        var mid = countY / 2;
        $('footer').css({
            'margin-top': '-' + mid + 'px',
            'padding-top': mid + 60
        });
    }

    if ($('.register-form-block').length > 0) {
        if (!isMobile()) {
            var countY = $('.register-form-block .container').outerHeight();
            var mid = countY / 2;
            var repo = mid + 60;
            $('.register-form-block').css({
                height: repo
            });

            $('.register-form-block .container').css({
                top: '-' + mid + 'px'
            });

            $('.register-form-block').prev().css({
                'margin-bottom': repo
            });

            $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': repo
            });

            $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': repo
            });

            var tabY = $('.tabs-wrap .tab.active').outerHeight();
            $('.tabs-wrap').height(tabY);
        }
        else {
            $('.register-form-block').css({
                height: ''
            });

            $('.register-form-block .container').css({
                top: ''
            });

            $('.register-form-block').prev().css({
                'margin-bottom': ''
            });

            $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': ''
            });

            $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': ''
            });

            var tabY = $('.tabs-wrap .tab.active').outerHeight();
            $('.tabs-wrap').height(tabY);
        }
    }
}

function isMobile() {
    return $(window).width() < 768;
}

function headingCheck() {
    if ($('.tabs-wrap .tab.success-screen').hasClass('active')) {
        $('.trade-registration-block .container > h2').hide();
    }
    else {
        $('.trade-registration-block .container > h2').show();
    }
}

var nextButtonLogic = function (classname) {

    var st = $('.tabs-wrap .tab .btn').offset().top;
    var tabN = $(classname).parents('.tab').next().height();
    var tabP = $(classname).parents('.tab').prev().height();
    $(classname).parents('.tab').animate({
        left: '-100%'
    });
    $(classname).parents('.tab').next().animate({
        left: '0'
    });
    $('.tabs-nav .tab.active').addClass('complete').removeClass('active').next().addClass('active');
    $(classname).parents('.tab').removeClass('active').next().addClass('active');
    $('.tabs-wrap').height(tabN);
    formPlacement();
    var spaceDifference0 = $('.tabs-wrap').parents('.trade-registration-block').innerHeight();
    var spaceDifference1 = $('.tabs-wrap').parents('.container').css('top').split('px');
    var correction = Math.abs(spaceDifference1[0]) + spaceDifference0;
    $('html').animate({
        scrollTop: st - 950
    })
    headingCheck();
    getTabHeightTradeJs();
}

var prevButtonLogic = function (classname) {
    var st = $('.tabs-wrap .tab .btn').offset().top;
    var tabP = $(this).parents('.tab').prev().height();
    $(classname).parents('.tab').animate({
        left: '100%'
    });
    $(classname).parents('.tab').prev().animate({
        left: '0'
    });
    $('.tabs-nav').show();
    $('.tabs-nav .tab.active').removeClass('active').prev().removeClass('complete').addClass('active');
    $(classname).parents('.tab').removeClass('active').prev().addClass('active');
    $('.tabs-wrap').height(tabP);
    formPlacement();
    var spaceDifference0 = $('.tabs-wrap').parents('.trade-registration-block').innerHeight();
    var spaceDifference1 = $('.tabs-wrap').parents('.container').css('top').split('px');
    var correction = Math.abs(spaceDifference1[0]) + spaceDifference0;
    $('html').animate({
        scrollTop: st - 950
    })
    headingCheck();
    getTabHeightTradeJs();
}

$(".company-details-back").on('click', function (e) {
    e.preventDefault();
});
function IsValidACN(acn) { //51 824 753 556
    acn = acn.replace(/ /g, ''); // strip spaces

    weight = [8, 7, 6, 5, 4, 3, 2, 1];
    weightedSum = 0;

    //0. ABN must be 11 digits long
    if (acn.length != 9 || isNaN(parseInt(acn))) {
        return false;
    }
    //Rules: 1,2,3  
    $.each(weight, function (i, val) {
        weightedSum += parseInt(acn[i]) * weight[i];
    });
    check = (10 - (weightedSum % 10)) % 10;
    //Rules: 4,5                 
    return acn[8] == check;
}
$("#company_preferred_jms").on("change", (e) => {
    const selectedSoftware = e.target.value;
    let otherSoftware = document.getElementById('other_software');
    let otherSoftwareLabel = document.getElementById('other_software_label');
    let errorOtherSoftwareLabel = document.getElementById('error-other-software');
    let errorOtherSoftwareCharLength = document.getElementById('error-other-softwareCharLength')
    let errorOtherSoftwareInvalidChar = document.getElementById('error-other-softwareInvalidChar')

    if (selectedSoftware === "Other") {
        otherSoftwareLabel.style.display = 'block';
        otherSoftware.style.display = 'block';
    } else {
        otherSoftwareLabel.style.display = 'none';
        otherSoftware.style.display = 'none';
        errorOtherSoftwareLabel.style.display = 'none';
        errorOtherSoftwareCharLength.style.display = 'none';
        errorOtherSoftwareInvalidChar.style.display = 'none';
    }
});

$("#company_business_type").change(function () {
    $("#getTrustDetails").html('');
    if ($('option:selected', this).val() == "0") {
        $("#getACN").html(get_ACN_HTML());
    }
    else {
        $("#getACN").html('');
    }
    if ($('option:selected', this).val() == "1") {
        $("#getTrustDetails").html(get_Trust_HTML());
        trust_radio_select();
    }
    else {
        $("#getTrustDetails").html('');
    }
    getTabHeightTradeJs();
});
function get_ACN_HTML() {
    var charLimitErrorMessage = document.getElementById('charLimitErrorMessage').value;
    var invalidCharErrorMessage = document.getElementById('charInvalidErrorMessage').value;
    var acnHtml = '';
    acnHtml += '<div class="fields-wrapper flex-center-space-between corporate-acn">';
    acnHtml += '	<div class="field-wrap">';
    acnHtml += '		<label for="company-acn">ACN<span class="mandate">*</span></label>';
    acnHtml += '		<input type="text" id="company-acn" name="company_acn" placeholder="ACN Number"><span id="error-company-acn" class="error-message" style="display:none"></span>';
    acnHtml += '        <span id="error-company-acnCharLength" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-company-acnInvalidChar" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    acnHtml += '	</div>';
    acnHtml += '</div>';
    return acnHtml;
}
function get_Trust_HTML() {
    var charLimitErrorMessage = document.getElementById('charLimitErrorMessage').value;
    var invalidCharErrorMessage = document.getElementById('charInvalidErrorMessage').value;
    var trustHtml = '';
    trustHtml += '<div class="field-wrap company-trust">';
    trustHtml += '	<div class="radiobox flex">';
    trustHtml += '		<input type="radio" name="entity" id="ent-company" class="trust-radio" value="0" checked>';
    trustHtml += '		<label for="ent-company">Company</label>';
    trustHtml += '		<input type="radio" name="entity" id="ent-ind" class="trust-radio" value="1">';
    trustHtml += '		<label for="ent-ind">Individual</label>';
    trustHtml += '	</div>';
    trustHtml += '</div>';
    trustHtml += '<div class="fields-wrapper flex-center-space-between company-trustdetails">';
    trustHtml += '	<div class="field-wrap">';
    trustHtml += '		<label for="trustee-name">Trustee Name<span class="mandate">*</span></label>';
    trustHtml += '		<input type="text" id="trustee-name" name="trustee_name" placeholder="Trustee Name"/><span id="error-trustee-name" class="error-message" style="display:none">Trustee Name is required</span>'; /*required*/
    trustHtml += '      <span id="error-trustee-nameCharLength" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-trustee-nameInvalidChar" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    trustHtml += '	</div>';
    trustHtml += '	<div class="field-wrap trustee-acn-wrap" id="div_put_acn">';
    trustHtml += '		<label for="acn">Trustee ACN<span class="mandate">*</span></label>';
    trustHtml += '		<input type="text" id="acn" name="trustee_acn" placeholder="ACN Number"/><span id="error-acn" class="error-message" style="display:none"></span>'; /*pattern = "^(\\s*\\d\\s*){9}$" required*/
    trustHtml += '      <span id="error-acnCharLength" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-acnInvalidChar" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    trustHtml += '	</div>';
    trustHtml += '</div>';
    return trustHtml;
}
function get_acn_div() {
    var acn_div = '';
    acn_div += '		<label for="acn">Trustee ACN<span class="mandate">*</span></label>';
    acn_div += '		<input type="text" id="acn" name="acn" placeholder="ACN Number"/><span id="error-acn" class="error-message" style="display:none"></span>';/*pattern = "^(\\s*\\d\\s*){9}$" required*/

    return acn_div;
}
function trust_radio_select() {
    $(".trust-radio").change(function () {
        if ($(this).val() == "1") {
            $("#div_put_acn").html('');
        }
        else {
            $("#div_put_acn").html(get_acn_div());
        }
    });
}

var companyCustomValidations = function () {
    if ($("#post-diff:checked").length > 0) {
        $("#business-legal-name").prop('required', true);
        $("#business-trading-name").prop('required', true);
        $("#business-add").prop('required', true);
        $("#business-postcode").prop('required', true);
        $("#business-suburb").prop('required', true);
    } else {
        $("#business-legal-name").prop('required', false);
        $("#business-trading-name").prop('required', false);
        $("#business-add").prop('required', false);
        $("#business-postcode").prop('required', false);
        $("#business-suburb").prop('required', false);
    }
}

$('.company-details-next').click(function (e) {
    var companyformValid = document.forms["company-details-form"].checkValidity();
    if (IsCompanyFormValid()) {
        var CompanyformDataArray = $('#company-details-form').serializeArray();
        companyDetailsJSON = serializeObject(CompanyformDataArray);
        nextButtonLogic(".company-details-next");
    } else {
        headingCheck();
        getTabHeightTradeJs();
    }
    return false;
});
$(".management-back").on('click', function (e) {
    e.preventDefault();
});

$('.management-next').click(function (e) {
    if (IsManagementFormValid()) {
        var ManagementformDataArray = $('#management-form').serializeArray();
        managementDetailsJSON = serializeObject(ManagementformDataArray);
        nextButtonLogic(".management-next");
    } else {
        headingCheck();
        getTabHeightTradeJs();
    }
    return false;
});

$(".trade-references-back").on('click', function (e) {
    e.preventDefault();
});
var getAge = function (dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

function ValidateAndSendEmail(token) {
    if (IsTradeFormValid()) {
        if (IsRecapchaValid(token)) {
            var tradeReferenceArray = $('#trade-references-form').serializeArray();
            tradeReferenceJSON = serializeObject(tradeReferenceArray);
            SendEmail();
        }
    } else {
        headingCheck();
        getTabHeightTradeJs();
    }
}

function IsRecapchaValid(token) {
    var isValid = true;
    var siteKey = document.getElementById('reCaptchaV3SiteKey').value;

    grecaptcha.ready(function () {
        grecaptcha.execute(siteKey, { action: 'trade_account_application' }).then(function (token) {
            $.ajax({
                method: "POST",
                dataType: 'JSON',
                url: "/trade-account-application/validaterecaptcha",
                async: false,
                data: JSON.stringify(token),
                contentType: "application/json",
                success: function (response) {
                    if (response.status == "Valid") {
                        $('#reCaptchaErrorMsgInner').html('');
                        $('#reCaptchaErrorMsg').hide();
                        isValid = true;
                    }
                    else {
                        $('#reCaptchaErrorMsgInner').html(response.status);
                        $('#reCaptchaErrorMsg').show();
                        isValid = false;
                    }
                },
                failure: function (response) {
                    $('#reCaptchaErrorMsgInner').html(response.status);
                    $('#reCaptchaErrorMsg').show();
                    $("#middys-overlay").hide();
                    isValid = false;
                }
            });
        });
    });
    return isValid;
}

function get_postal_additional_detailsHTML() {
    var charLimitErrorMessage = document.getElementById('charLimitErrorMessage').value;
    var invalidCharErrorMessage = document.getElementById('charInvalidErrorMessage').value;
    var additionalDetailsHTML = '';
    additionalDetailsHTML += '<div class="field-wrap">';
    additionalDetailsHTML += '	<label for="company-additional-business-address">Street Address<span class="mandate">*</span></label>';
    additionalDetailsHTML += '	<input type="text" id="business-add" name="postal_address" placeholder="Address"/><span id="error-buss-address" class="error-message" style="display:none">Street Address is required</span>';
    additionalDetailsHTML += '<span id="error-buss-addressCharLength" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-buss-addressInvalidChar" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    additionalDetailsHTML += '</div>';
    additionalDetailsHTML += '<div class="fields-wrapper flex-center-space-between">';
    additionalDetailsHTML += '	<div class="field-wrap">';
    additionalDetailsHTML += '		<label for="company-additional-business-postcode">Postcode<span class="mandate">*</span></label>';
    additionalDetailsHTML += '		<input type="text" id="business-postcode" placeholder="Postcode"/><input type="hidden" id="business-postcode-hidden" name="postal_postcode"/><span id="error-buss-postcode" class="error-message" style="display:none">Postcode is required</span>';
    additionalDetailsHTML += '<span id="error-buss-postcodeCharLength" class="error-message" style="display:none">' + charLimitErrorMessage + 'n</span><span id="error-buss-postcodeInvalidChar" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    additionalDetailsHTML += '	</div>';
    additionalDetailsHTML += '	<div class="field-wrap">';
    additionalDetailsHTML += '		<label for="company-additional-business-suburb">Suburb<span class="mandate">*</span></label>';
    additionalDetailsHTML += '		<input type="text" id="business-suburb" placeholder="Suburb"/><input type="hidden" id="business-suburb-hidden"  name="postal_suburb"/><span id="error-buss-suburb" class="error-message" style="display:none">Suburb is required</span>';
    additionalDetailsHTML += '<span id="error-buss-suburbCharLength" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-buss-suburbInvalidChar" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    additionalDetailsHTML += '	</div>';
    additionalDetailsHTML += '</div>';

    return additionalDetailsHTML;
}
function add_diff_htmls() {

    //Sales Main Contact*
    $('#sales-diff').change(function () {
        if (this.checked) {
            $("#sales_main_contact").html(get_sales_main_contactHTML());
        } else {
            $("#sales_main_contact").html('');
        }
    });
    $('#sales-same').change(function () {
        if (this.checked) {
            $("#sales_main_contact").html('');
        } else {
            $("#sales_main_contact").html(get_sales_main_contactHTML());
        }
    });
    //myAccount Main Contact*
    $('#my-diff').change(function () {
        if (this.checked) {
            $("#myaccount_main_contact").html(get_myaccount_main_contactHTML());
        } else {
            $("#myaccount_main_contact").html('');
        }
    });
    $('#my-same').change(function () {
        if (this.checked) {
            $("#myaccount_main_contact").html('');
        } else {
            $("#myaccount_main_contact").html(get_myaccount_main_contactHTML());
        }
    });

    //postal address
    $('#post-diff').change(function () {
        if (this.checked) {
            $("#postal-address").html(get_postal_additional_detailsHTML());
            get_address_finder('#business-add', '#business-postcode', '#business-suburb');
        } else {
            $("#postal-address").html('');
        }
        getTabHeightTradeJs();
    });
    $('#post-same').change(function () {
        if (this.checked) {
            $("#postal-address").html('');
        } else {
            $("#postal-address").html(get_postal_additional_detailsHTML());
        }
        getTabHeightTradeJs();
    });
}

//address finder
//function initialize_tradeaccount() {
//    get_branch_suggestions('branch-search');

//}
function get_address(input, postcode, suburb) {
    var _add = document.getElementById(input);
    map_location_settings(_add, postcode, suburb);
}
function map_location_settings(input, postcode, suburb) {
    var options = {
        types: ['(regions)'],
        componentRestrictions: { country: 'au' }
    };
    var autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.addListener('place_changed', function () {
        $(postcode).val('');
        $(postcode).prop('disabled', false);
        $(postcode + "-hidden").val('');
        $(suburb).val('');
        $(suburb).prop('disabled', false);
        $(suburb + "-hidden").val('');
        get_place(autocomplete, postcode, suburb);
    });
}
function get_current_position(input) {
    var browserAccess = "";
    navigator.geolocation.getCurrentPosition(position => {
        browserAccess = "granted";
        selectedlatitude = position.coords.latitude;
        selectedlongitude = position.coords.longitude;
        if (input.value == "" && browserAccess == "granted") {
            currentLocationData();
        }
        else {
            clearSearchTextBox();
        }

    }, error => {
        browserAccess = "denied";
        clearSearchTextBox();
    }, {
        timeout: 10000,
        maximumAge: 10000,
        enableHighAccuracy: true
    })
}
function get_place(autocomplete, postcode, suburb) {
    var place = autocomplete.getPlace();

    if (place.hasOwnProperty('address_components')) {
        for (const component of place.address_components) {
            const componentType = component.types[0];
            switch (componentType) {
                case "subpremise": {
                    break;
                }
                case "street_number": {
                    break;
                }
                case "locality": {
                    if (suburb !== '' && component.short_name !== '') {
                        $(suburb).val(component.short_name);
                        $(suburb).prop('disabled', true);
                    }
                    break;
                }
                case "administrative_area_level_1": {
                    break;
                }
                case "postal_code": {
                    if (postcode !== '' && component.short_name !== '') {
                        $(postcode).val(component.short_name);
                        $(postcode + "-hidden").val(component.short_name);
                        $(postcode).prop('disabled', true);
                    }
                    break;
                }
                default: {

                }
            }

        }
    }
}
//branch suggetion
var branchChunkData = [];
var currentChunk = 0;
document.addEventListener('DOMContentLoaded', function () {
    new AddressFinder({
        targetInputId: 'branch-search',
        showAddresses: false,
        showLocations: true,
        onSelect: function (fullAddress, metaData) {
            selectedlatitude = metaData.latitude;
            selectedlongitude = metaData.longitude;

            $("#branch-search").val('');
            $("#branch-selection-box").html('');

            branchChunkData = [];
            currentChunk = 0;
            BindBranchListAutosuggestion(selectedlatitude, selectedlongitude);
        }
    });
});
function _AntiForgeryToken(id) {
    $.ajax({
        url: "/login/RefreshToken",
        type: "GET",
        dataType: "json",
        beforeSend: function (xhr) {
            xhr.setRequestHeader('Content-Type', 'application/json');
        },
        success: function (data) {
            //console.log(data);
        },
        complete: function (data) {
            //console.log("Hello", data);
            $(id).html(data.responseText);
            // Set our complete callback,
        },
        error: function (e) {
            //alert("error");
        }
    });
}
function BindBranchListAutosuggestion(selectedlatitude, selectedlongitude) {
    jQuery.ajax({
        type: "GET",
        async: false,
        url: "/api/BranchLocator/SearchBranchByLatLong",
        dataType: "json",
        data: {
            latitude: selectedlatitude,
            longitude: selectedlongitude
        },
        beforeSend: function (xhr) {
            xhr.setRequestHeader('RequestVerificationToken', $("#checkloginApi [name='__RequestVerificationToken']").val());
        },
        success: function (data) {
            bindBranchSuggestionHtml(data);
            _AntiForgeryToken("#checkloginApi");
        }
    });
}
function bindBranchSuggestionHtml(data) {
    const chunkSize = 5;
    if (data.length > chunkSize) {
        for (let i = 0; i < data.length; i += chunkSize) {
            const chunk = data.slice(i, i + chunkSize);
            branchChunkData.push(chunk);
        }
    } else {
        branchChunkData[0] = data;
    }
    get_default_branch_suggestion(branchChunkData[currentChunk], currentChunk);
}
function get_default_branch_suggestion(data, currentChunk) {

    var oldHtml = $("#branch-selection-box").html();
    var BranchesHTML = "";
    var showMoreHTML = '';

    showMoreHTML += '<div class="flex-center-center">';
    showMoreHTML += '	<a href="javascript:void(0)" class="show-more">Show more</a>';
    showMoreHTML += '</div>';

    $.each(data, function (index) {
        BranchesHTML += '<div class="branch flex-center-space-between branch-suggestion" data-name="' + data[index].name + '" data-address="' + data[index].address.replace(/"/ig, "") + ', ' + data[index].suburb + ', ' + data[index].state + ', ' + data[index].postcode + '" data-phone="' + data[index].telephone + '" data-email="' + data[index].email + '" data-url="' + "/branch-locator/" + data[index].state.toLowerCase().trim() + "/" + data[index].slug + '">';
        BranchesHTML += '	<div class="branch-data">';
        BranchesHTML += '		<label>Middy\'s ' + data[index].name + '</label > ';
        BranchesHTML += '		<span>' + data[index].address + ', ' + data[index].suburb + ', ' + data[index].state + ', ' + data[index].postcode + '</span>';
        BranchesHTML += '	</div>';
        BranchesHTML += '	<span class="distance">' + data[index].distance.toFixed(2) + 'km</span>';
        BranchesHTML += '</div>';
    });

    $("#branch-selection-box").html(oldHtml + BranchesHTML);

    if (branchChunkData.length - 1 != currentChunk) {
        $("#show-more").html(showMoreHTML);
    }
    $("#show-more").show();
    if (branchChunkData.length - 1 == currentChunk) {
        $("#show-more").hide();
    }

    if (currentChunk == 0) {
        $("#parent-branch-selection-box").show();
    }
    show_more_click();
    branch_suggestion_click();
}
function show_more_click() {
    $(".show-more").click(function () {
        currentChunk = currentChunk + 1;
        if (branchChunkData.length > 0 && branchChunkData.length > currentChunk) {
            get_default_branch_suggestion(branchChunkData[currentChunk], currentChunk);
        }

    });
}
var branchDetails;
function branch_suggestion_click() {
    $(".branch-suggestion").click(function () {
        branchDetails = {
            BranchName: $(this).attr("data-name"),
            BranchAddress: $(this).attr("data-address"),
            BranchPhone: $(this).attr("data-phone"),
            BranchEmail: $(this).attr("data-email")
        };
        var branchUrl = window.location.origin + $(this).attr("data-url");
        $("#parent-branch-selection-box").hide();
        var selectedBranchHtml = '';
        selectedBranchHtml += '<div class="branch-data">';
        selectedBranchHtml += '	<label>Middy\'s ' + branchDetails.BranchName + '</label>';
        selectedBranchHtml += '	<span>' + branchDetails.BranchAddress + '</span>';
        selectedBranchHtml += '</div>';
        selectedBranchHtml += '<a href="javascript:void(0)" class="remove" id="remove-selected-branch"></a>';
        $("#branch-search").val("Middy's " + branchDetails.BranchName);
        $("#branch-search").prop('required', false);
        $("#branch-search").hide();
        $("#branch-selected").html(selectedBranchHtml);
        $("#branch-selected").show();
        $(".success-branchname").text("Middy's " + branchDetails.BranchName);
        $(".success-branchname").attr("href", branchUrl);
        remove_selected_branch_click();
        getTabHeightTradeJs();
    });
}
function remove_selected_branch_click() {
    $("#remove-selected-branch").click(function () {
        $("#branch-selected").html('');
        $("#branch-selected").hide();

        $("#branch-search").val('');
        $("#branch-search").prop('required', true);
        $("#branch-search").show();
        getTabHeightTradeJs();
    });
}

//add management person details
function get_management_person_details_html(id) {
    var charLimitErrorMessage = document.getElementById('charLimitErrorMessage').value;
    var invalidCharErrorMessage = document.getElementById('charInvalidErrorMessage').value;
    var company_details_html = '';
    var ref_id = parseInt(id) + 1;
    company_details_html += '<div id="div_management_' + ref_id + '">';
    company_details_html += '<span class="title" id="management_title_' + ref_id + '">Person ' + ref_id + '</span>';
    company_details_html += '<a href="#" class="remove_management" id="management_' + ref_id + '" data-id="div_management_' + ref_id + '" data-value="' + ref_id + '">Remove</a>';
    company_details_html += '<div class="person-group management_person" >';
    company_details_html += '	<div class="fields-wrapper flex-center-space-between">';
    company_details_html += '		<div class="field-wrap">';
    company_details_html += '			<label for="management-first-name' + id + '">First Name<span class="mandate">*</span></label>';
    company_details_html += '			<input type="text" id="management-first-name' + id + '" name="management_first_name' + id + '" placeholder="First Name" /> <span id="error-management-first-name' + id + '" class="error-message" style="display:none">First Name is required</span>';
    company_details_html += '           <span id="error-management-first-nameCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-management-first-nameInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    company_details_html += '		</div>';
    company_details_html += '		<div class="field-wrap">';
    company_details_html += '			<label for="management-last-name' + id + '">Last Name<span class="mandate">*</span></label>';
    company_details_html += '			<input type="text" id="management-last-name' + id + '" name="management_last_name' + id + '" placeholder="Last Name" /><span id="error-management-last-name' + id + '" class="error-message" style="display:none">Last Name is required</span>';
    company_details_html += '           <span id="error-management-last-nameCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-management-last-nameInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    company_details_html += '		</div>';
    company_details_html += '	</div>';
    company_details_html += '	<div class="fields-wrapper flex-center-space-between">';
    company_details_html += '		<div class="field-wrap">';
    company_details_html += '			<label for="management-birth-date' + id + '">Date of Birth<span class="mandate">*</span></label>';
    company_details_html += '			<input type="date" min="1900-01-01" max="' + new Date().getFullYear() + '-12-31" id="management-birth-date' + id + '" name="management_birth_date' + id + '" placeholder="DD/MM/YYYY"  required/><span id="error-management-birth-date' + id + '" class="error-message" style="display:none"></span>';
    company_details_html += '           <span id="error-management-birth-dateCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-management-birth-dateInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    company_details_html += '		</div>';
    company_details_html += '		<div class="field-wrap">';
    company_details_html += '			<label for="management-drivers-licence' + id + '">Driver License<span class="mandate">*</span></label>';
    company_details_html += '			<input type="text" id="management-drivers-licence' + id + '" name="management_drivers_licence' + id + '" placeholder="License Number"/><span id="error-management-drivers-licence' + id + '" class="error-message" style="display:none">Drivers Licence is required</span>';
    company_details_html += '           <span id="error-management-drivers-licenceCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-management-drivers-licenceInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    company_details_html += '		</div>';
    company_details_html += '	</div>';
    company_details_html += '	<div class="field-wrap">';
    company_details_html += '		<label for="management-add' + id + '">Address<span class="mandate">*</span></label>';
    company_details_html += '		<input type="text" id="management-add' + id + '" name="management_add' + id + '" placeholder="Address"/><span id="error-management-add' + id + '" class="error-message" style="display:none">Address is required</span>';
    company_details_html += '       <span id="error-management-addCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-management-addInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    company_details_html += '	</div>';
    company_details_html += '	<div class="fields-wrapper flex-center-space-between">';
    company_details_html += '		<div class="field-wrap">';
    company_details_html += '			<label for="management-postcode' + id + '">Postcode<span class="mandate">*</span></label>';
    company_details_html += '			<input type="text" id="management-postcode' + id + '" placeholder="Postcode" /> <input type="hidden" id="management-postcode' + id + '-hidden" name="management_postcode' + id + '" /><span id="error-management-postcode' + id + '" class="error-message" style="display:none">Postcode is required</span>';
    company_details_html += '           <span id="error-management-postcodeCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-management-postcodeInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    company_details_html += '		</div>';
    company_details_html += '		<div class="field-wrap">';
    company_details_html += '			<label for="management-suburb' + id + '">Suburb<span class="mandate">*</span></label>';
    company_details_html += '			<input type="text" id="management-suburb' + id + '" placeholder="Suburb" /><input type="hidden" id="management-suburb' + id + '-hidden" name="management_suburb' + id + '" /><span id="error-management-suburb' + id + '" class="error-message" style="display:none">Suburb is required</span>';
    company_details_html += '           <span id="error-management-suburbCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-management-suburbInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    company_details_html += '		</div>';
    company_details_html += '	</div>';
    company_details_html += '</div>';
    company_details_html += '</div>';
    return company_details_html;
}
function add_default_management_person_details_form(ele_id) {
    $("#management_person_details").append(get_management_person_details_html(ele_id));
    //get_address('management-add' + ele_id, '#management-postcode' + ele_id, '#management-suburb' + ele_id);
    get_address_finder('#management-add' + ele_id, '#management-postcode' + ele_id, '#management-suburb' + ele_id);

}
function remove_management_html(id) {

    var selectorId = parseInt(id) + 1;
    $('#management_' + selectorId).click(function (e) {
        var div_id = $(this).attr("data-id");
        var id = $(this).attr("data-value");

        $('#' + div_id).remove();
        var management_person_forms_count = $('.management_person').length;
        if (management_person_forms_count < 3) {
            $("#add_another_management_person").show();
        }

        if (id == management_person_forms_count) {
            var ele_id = parseInt(id) + 1;
            var iid = parseInt(id) - 1;

            //title
            $('#management_title_' + ele_id).html('Person ' + id);
            //management-first-name
            $('#management-first-name' + id).attr('name', 'management-first-name' + iid);
            $('#management-first-name' + id).attr('id', 'management-first-name' + iid);

            //management-last-name
            $('#management-last-name' + id).attr('name', 'management-last-name' + iid);
            $('#management-last-name' + id).attr('id', 'management-last-name' + iid);

            //management-birth-date
            $('#management-birth-date' + id).attr('name', 'management-birth-date' + iid);
            $('#management-birth-date' + id).attr('id', 'management-birth-date' + iid);

            //management-drivers-licence
            $('#management-drivers-licence' + id).attr('name', 'management-drivers-licence' + iid);
            $('#management-drivers-licence' + id).attr('id', 'management-drivers-licence' + iid);

            //management-add
            $('#management-add' + id).attr('name', 'management-add' + iid);
            $('#management-add' + id).attr('id', 'management-add' + iid);

            //management-postcode
            $('#management-postcode' + id).attr('name', 'management-postcode' + iid);
            $('#management-postcode' + id).attr('id', 'management-postcode' + iid);

            //management-add
            $('#management-suburb' + id).attr('name', 'management-suburb' + iid);
            $('#management-suburb' + id).attr('id', 'management-suburb' + iid);

            //console.log(ele_id,id);
            $('#div_management_' + ele_id).attr('id', 'div_management_' + id);//div_trade_

            $('#management_' + ele_id).attr('data-value', id);
            $('#management_' + ele_id).attr('data-id', 'div_management_' + id);//div_trade_
            $('#management_' + ele_id).attr('id', 'management_' + id);//trade_
            $('#management_title_' + ele_id).attr('id', 'management_title_' + id);//title_
        }
        getTabHeightTradeJs();
        e.preventDefault();
    });
}
function management_person_button_click() {
    $("#add_another_management_person").click(function (e) {
        var management_person_forms_count = $('.management_person').length;
        if (management_person_forms_count < 3) {
            add_default_management_person_details_form(management_person_forms_count);
            remove_management_html(management_person_forms_count);
        }
        if (management_person_forms_count == 2) {
            $(this).hide();
        }
        getTabHeightTradeJs();
        e.preventDefault();
    });
}
//add trade references
function get_trade_references_html(id) {
    var charLimitErrorMessage = document.getElementById('charLimitErrorMessage').value;
    var invalidCharErrorMessage = document.getElementById('charInvalidErrorMessage').value;

    var trade_references_html = '';
    var ref_id = parseInt(id) + 1;
    trade_references_html += '<div id="div_trade_' + ref_id + '">';
    trade_references_html += '<span class="title" id="title_' + ref_id + '">Reference ' + ref_id + '</span>';
    trade_references_html += '<a href="#" class="remove_trade" id="trade_' + ref_id + '" data-id="div_trade_' + ref_id + '" data-value="' + ref_id + '">Remove</a>';
    trade_references_html += '<div class="fields-wrapper flex-center-space-between trade_references_person">';
    trade_references_html += '	<div class="field-wrap">';
    trade_references_html += '		<label for="trade-reference-company-name' + id + '">Company Name<span class="mandate">*</span></label>';
    trade_references_html += '		<input type="text" id="company-name' + id + '" name="trade_reference_company_name' + id + '" placeholder="Company Name"/><span id="error-company-name' + id + '" class="error-message" style="display:none">Company Name is required</span>';
    trade_references_html += '      <span id="error-company-nameCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-company-nameInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    trade_references_html += '	</div>';
    trade_references_html += '</div>';
    trade_references_html += '<div class="reference-group">';
    trade_references_html += '	<div class="fields-wrapper flex-center-space-between">';
    trade_references_html += '		<div class="field-wrap">';
    trade_references_html += '			<label for="trade-reference-first-name' + id + '">First Name<span class="mandate">*</span></label>';
    trade_references_html += '			<input type="text" id="company-first-name' + id + '" name="trade_reference_first_name' + id + '" placeholder="First Name" /><span id="error-company-first-name' + id + '" class="error-message" style="display:none">First Name is required</span>';
    trade_references_html += '          <span id="error-company-first-nameCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-company-first-nameInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    trade_references_html += '		</div>';
    trade_references_html += '		<div class="field-wrap">';
    trade_references_html += '			<label for="trade-reference-last-name' + id + '">Last Name<span class="mandate">*</span></label>';
    trade_references_html += '			<input type="text" id="company-last-name' + id + '" name="trade_reference_last_name' + id + '" placeholder="Last Name"/><span id="error-company-last-name' + id + '" class="error-message" style="display:none">Last Name is required</span>';
    trade_references_html += '          <span id="error-company-last-nameCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-company-last-nameInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    trade_references_html += '		</div>';
    trade_references_html += '	</div>';
    trade_references_html += '	<div class="fields-wrapper flex-center-space-between">';
    trade_references_html += '		<div class="field-wrap">';
    trade_references_html += '			<label for="trade-reference-contact' + id + '">Contact Number<span class="mandate">*</span></label>';
    trade_references_html += '			<input type="text" id="company-number' + id + '" name="trade_reference_contact' + id + '" placeholder="Phone Number"/><span id="error-company-number' + id + '" class="error-message" style="display:none"></span>';
    trade_references_html += '          <span id="error-company-numberCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-company-numberInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    trade_references_html += '		</div>';
    trade_references_html += '		<div class="field-wrap">';
    trade_references_html += '			<label for="trade-reference-email' + id + '">Email Address<span class="mandate">*</span></label>';
    trade_references_html += '			<input type="text" id="company-email' + id + '" name="trade_reference_email' + id + '" placeholder="Email Address"/> <span id="error-company-email' + id + '" class="error-message" style="display:none">Email Address is required</span>';
    trade_references_html += '          <span id="error-company-emailCharLength' + id + '" class="error-message" style="display:none">' + charLimitErrorMessage + '</span><span id="error-company-emailInvalidChar' + id + '" class="error-message" style="display:none">' + invalidCharErrorMessage + '</span>';
    trade_references_html += '		</div>';
    trade_references_html += '	</div>';
    trade_references_html += '</div>';
    trade_references_html += '</div>';

    return trade_references_html;
}
function add_default_trade_references_form(ele_id) {
    $("#trade_references_details").append(get_trade_references_html(ele_id));

}
function trade_references_button_click() {
    $("#add_another_trade_references").click(function (e) {
        var trade_references_count = $('.trade_references_person').length;
        if (trade_references_count < 3) {
            add_default_trade_references_form(trade_references_count);
            remove_trade_html(trade_references_count);
        }
        if (trade_references_count == 2) {
            $(this).hide();
        }

        getTabHeightTradeJs();
        e.preventDefault();
    });
}
function remove_trade_html(id) {
    var selectorId = parseInt(id) + 1;
    $('#trade_' + selectorId).click(function (e) {
        var div_id = $(this).attr("data-id");
        var id = $(this).attr("data-value");


        $('#' + div_id).remove();
        var trade_forms_count = $('.trade_references_person').length;
        if (trade_forms_count < 3) {
            $("#add_another_trade_references").show();
        }

        if (id == trade_forms_count) {
            var ele_id = parseInt(id) + 1;
            var iid = parseInt(id) - 1;
            //title
            $('#title_' + ele_id).html('Reference ' + id);
            //company-name
            $('#company-name' + id).attr('name', 'trade-reference-company-name' + iid);
            $('#company-name' + id).attr('id', 'company-name' + iid);

            //company-first-name
            $('#company-first-name' + id).attr('name', 'trade-reference-first-name' + iid);
            $('#company-first-name' + id).attr('id', 'company-first-name' + iid);

            //company-last-name
            $('#company-last-name' + id).attr('name', 'trade-reference-last-name' + iid);
            $('#company-last-name' + id).attr('id', 'company-last-name' + iid);

            //company-number
            $('#company-number' + id).attr('name', 'trade-reference-contact' + iid);
            $('#company-number' + id).attr('id', 'company-number' + iid);

            //company-email
            $('#company-email' + id).attr('name', 'trade-reference-email' + iid);
            $('#company-email' + id).attr('id', 'company-email' + iid);

            $('#div_trade_' + ele_id).attr('id', 'div_trade_' + id);
            $('#trade_' + ele_id).attr('data-value', id);
            $('#trade_' + ele_id).attr('data-id', 'div_trade_' + id);
            $('#trade_' + ele_id).attr('id', 'trade_' + id);
            $('#title_' + ele_id).attr('id', 'title_' + id);
        }
        getTabHeightTradeJs();
        e.preventDefault();
    });
}

// tab resize
function getTabHeightTradeJs() {
    var tabActive = $('.tabs-wrap .tab.active').height();
    $('.tabs-wrap').animate({
        height: tabActive
    })
    setTimeout(formPlacement, 500)
}

function serializeObject(formDataArray) {
    var o = {};
    var a = formDataArray;
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

var initTA = function () {
    get_address_finder('#company-add', '#company-postcode', '#company-suburb');
    get_address_finder('#management-add', '#man-postcode', '#man-suburb');
};


function get_address_finder(input, postcode, suburb) {
    clear_postcode_suburb(input, postcode, suburb);
    new AddressFinder({
        targetInputId: input.replace("#",""),
        showAddresses: true,
        showLocations: false,
        onSelect: function (fullAddress, metaData) {
            $(input).val(metaData.place.address + ", " + metaData.place.state);
            var suburbData = metaData.place.locality;
            var postcodeData = metaData.place.postcode;
            if (postcodeData) {
                //$(postcode + "-hidden").val(postcodeData);
                $(postcode).val(postcodeData);
                $(postcode).prop('disabled', true);
            }
            if (suburbData) {
                // $(suburb + "-hidden").val(suburbData);
                $(suburb).val(suburbData);
                $(suburb).prop('disabled', true);
            }
        }
    });
}
function clear_postcode_suburb(input, postcode, suburb) {
    $(input).keyup(function () {
        $(postcode).val('');
        $(postcode).prop('disabled', false);
        $(postcode + "-hidden").val('');
        $(suburb).val('');
        $(suburb).prop('disabled', false);
        $(suburb + "-hidden").val('');
    });
}



$(document).ready(function () {

    let contactDetailsJSON = {};
    let companyDetailsJSON = {};
    let managementDetailsJSON = {};
    let tradeReferenceJSON = {};
    management_person_button_click();
    //trade references form 
    trade_references_button_click();
    // add diff htmls
    add_diff_htmls();

    initTA();
});

var SendEmail = function () {
    var tradeDetails = {
        contactDetails: contactDetailsJSON,
        companyDetails: companyDetailsJSON,
        managementDetails: managementDetailsJSON,
        referenceDetails: tradeReferenceJSON,
        branchDetails: branchDetails
    };

    document.getElementById('SubmissionErrorMessage').style.display = "none";

    $.ajax({
        method: "POST",
        dataType: 'text',
        url: "/trade-account-application/print",
        async: false,
        data: JSON.stringify(tradeDetails),
        contentType: "application/json",
        beforeSend: function (request) {
            request.setRequestHeader("RequestVerificationToken", $("#trade-references-form [name='__RequestVerificationToken']").val());
        },
        success: function (response) {
            //make sure response does not contain any unhandled error
            if (!response.includes("<html>")) {
                if (response.startsWith("1")) { //something is wrong with form data submission
                    document.getElementById("SubmissionErrorMessage").innerHTML = response.slice(1);
                    document.getElementById('SubmissionErrorMessage').style.display = "block";
                }
                else {
                    if (response == 'false') {
                        $(".email-success").hide();
                        $(".email-failure").show();
                    }

                    nextButtonLogic(".trade-references-next");
                    $("#tab-navigation").hide();
                }
            }
        },
        failure: function (data) {
            document.getElementById("SubmissionErrorMessage").innerHTML = data;
            document.getElementById('SubmissionErrorMessage').style.display = "block";

            $(".email-success").hide();
            $(".email-failure").show();
        }
    })
        .fail(function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status == 400 || textStatus == "error") {
                document.getElementById("SubmissionErrorMessage").innerHTML = $("#formSubmissionErrorMessage").val();
                document.getElementById('SubmissionErrorMessage').style.display = "block";
            }
        });
}


var IsContactFormValid = function () {
    var isValid = true;
    if (!ValidateFirstName())
        isValid = false;
    if (!ValidateLastName())
        isValid = false;
    if (!ValidateContactEmail())
        isValid = false;
    if (!ValidateTitle())
        isValid = false;
    if (!ValidatePhoneAndMobile())
        isValid = false;
    return isValid;
}


ValidateFirstName = function () {
    $("#contact-fname-error, #contact-fname-errorCharLength, #contact-fname-errorInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#trade-fname', '#contact-fname-error');
    if (isValid) {
        isValid = CharLengthValidation('#trade-fname', 50, '#contact-fname-errorCharLength');
    }
    if (isValid) {
        isValid = InvalidNameCharValidation('#trade-fname', '#contact-fname-errorInvalidChar');
    }
    return isValid;
}
ValidateLastName = function () {
    $("#contact-lname-error, #contact-lname-errorCharLength, #contact-lname-errorInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#trade-lname', '#contact-lname-error');
    if (isValid) {
        isValid = CharLengthValidation('#trade-lname', 50, '#contact-lname-errorCharLength');
    }
    if (isValid) {
        isValid = InvalidNameCharValidation('#trade-lname', '#contact-lname-errorInvalidChar');
    }
    return isValid;
}
ValidateContactEmail = function () {
    $("#contact-email-error, #contact-email-errorCharLength, #contact-email-errorInvalidChar").hide();

    var isValid = true;
    isValid = ValidateEmail('#trade-email', '#contact-email-error');
    if (isValid) {
        isValid = CharLengthValidation('#trade-email', 60, '#contact-email-errorCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#trade-email', '#contact-email-errorInvalidChar', true);
    }
    return isValid;
}

ValidateEmail = function (fieldId, fieldError) {
    var email = $(fieldId).val();
    if (email == "" || email == null || email == undefined) {
        $(fieldId).addClass("field-error");
        $(fieldError).text('Email Address is required');
        $(fieldError).show();
        return false;
    }
    else if (!ValidateEmailRegex(email)) {
        $(fieldId).addClass("field-error");
        $(fieldError).text('Email Address is required');
        $(fieldError).show();
        return false;
    }
    else {
        $(fieldId).removeClass("field-error");
        $(fieldError).text('');
        $(fieldError).hide();
        return true;
    }
}
ValidateTitle = function () {
    $("#contact-title-error, #contact-title-errorCharLength, #contact-title-errorInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#trade-job', '#contact-title-error');
    if (isValid) {
        isValid = CharLengthValidation('#trade-job', 50, '#contact-title-errorCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#trade-job', '#contact-title-errorInvalidChar');
    }
    return isValid;
}

ValidatePhoneAndMobile = function () {
    $("#contact-mobile-error").hide();
    $("#contact-mobile-errorCharLength").hide();
    $("#contact-mobile-errorInvalidChar").hide();

    $("#contact-phone-error").hide();
    $("#contact-phone-errorCharLength").hide();
    $("#contact-phone-errorInvalidChar").hide();

    var mobile = $("#trade-mob").val(); var phone = $("#trade-phone").val();
    if (!mobile && !phone) {
        $('#trade-mob').addClass("field-error");
        $('#trade-phone').addClass("field-error");
        $("#contact-mobile-error").text("Either Mobile or Phone (Other) is required");
        $("#contact-mobile-error").show();
        return false;
    }
    else {
        var contactValid = true;
        if (!ValidateMobile1(mobile))
            contactValid = false;
        if (!ValidatePhone1(phone))
            contactValid = false;
        return contactValid;
    }
}
ValidateMobile1 = function (mobile) {
    if (mobile.length > 15) {
        $('#trade-mob').addClass("field-error");
        $("#contact-mobile-errorCharLength").show();
        return false;
    }
    else if (mobile && !IsMobileValid(mobile)) {
        $('#trade-mob').addClass("field-error");
        $("#contact-mobile-error").text("Mobile number is required");
        $("#contact-mobile-error").show();
        return false;
    }
    else {
        $('#trade-mob').removeClass("field-error");
        $("#contact-mobile-error").hide();
        $("#contact-mobile-errorCharLength").hide();
        $("#contact-mobile-errorInvalidChar").hide();
        return true;
    }
}
ValidatePhone1 = function (phone) {
    if (phone.length > 15) {
        $('#trade-phone').addClass("field-error");
        $("#contact-phone-errorCharLength").show();
        return false;
    }
    else if (phone && !ValidatePhoneRegex(phone)) {
        $('#trade-phone').addClass("field-error");
        $("#contact-phone-error").text("Contact number is required");
        $("#contact-phone-error").show();
        return false;
    }
    else {
        $('#trade-phone').removeClass("field-error");
        $("#contact-phone-error").hide();
        $("#contact-phone-errorCharLength").hide();
        $("#contact-phone-errorInvalidChar").hide();
        return true;
    }
}
ValidateLegalName = function () {
    $("#company-legalname-error, #company-legalname-errorCharLength, #company-legalname-errorInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#legal-name', '#company-legalname-error');
    if (isValid) {
        isValid = CharLengthValidation('#legal-name', 100, '#company-legalname-errorCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#legal-name', '#company-legalname-errorInvalidChar');
    }
    return isValid;
}
ValidateTradingName = function () {
    $("#company-tradingname-error, #company-tradingname-errorCharLength, #company-tradingname-errorInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#trading-name', '#company-tradingname-error');
    if (isValid) {
        isValid = CharLengthValidation('#trading-name', 100, '#company-tradingname-errorCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#trading-name', '#company-tradingname-errorInvalidChar');
    }
    return isValid;
}
ValidateAddress = function () {
    $("#company-address-error, #company-address-errorCharLength, #company-address-errorInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#company-add', '#company-address-error');
    if (isValid) {
        isValid = CharLengthValidation('#company-add', 100, '#company-address-errorCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation_MiddysBranchSearch('#company-add', '#company-address-errorInvalidChar');
    }
    return isValid;
}
ValidatePostcode = function () {
    $("#company-postcode-error, #company-postcode-errorCharLength, #company-postcode-errorInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#company-postcode', '#company-postcode-error');
    if (isValid) {
        isValid = CharLengthValidation('#company-postcode', 4, '#company-postcode-errorCharLength');
    }
    if (isValid) {
        isValid = PostcodeValidation('#company-postcode', '#company-postcode-error');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#company-postcode', '#company-postcode-errorInvalidChar');
    }
    $("#company-postcode-hidden").val($("#company-postcode").val());
    return isValid;
}
ValidateSuburb = function () {
    $("#company-suburb-error, #company-suburb-errorCharLength, #company-suburb-errorInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#company-suburb', '#company-suburb-error');
    if (isValid) {
        isValid = CharLengthValidation('#company-suburb', 50, '#company-suburb-errorCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#company-suburb', '#company-suburb-errorInvalidChar');
    }
    $("#company-suburb-hidden").val($("#company-suburb").val());
    return isValid;
}
ValidateBusinessAddress = function () {
    $("#error-buss-address, #error-buss-addressCharLength, #error-buss-addressInvalidChar").hide();

    if ($("#post-diff:checked").length > 0) {
        var isValid = true;
        isValid = RequiredFieldValidation('#business-add', '#error-buss-address');
        if (isValid) {
            isValid = CharLengthValidation('#business-add', 100, '#error-buss-addressCharLength');
        }
        if (isValid) {
            isValid = InvalidCharValidation_MiddysBranchSearch('#business-add', '#error-buss-addressInvalidChar');
        }
        return isValid;
    }
    return true;
}
ValidateBusinessPostcode = function () {
    $("#error-buss-postcode, #error-buss-postcodeCharLength, #error-buss-postcodeInvalidChar").hide();

    if ($("#post-diff:checked").length > 0) {
        var isValid = true;
        isValid = RequiredFieldValidation('#business-postcode', '#error-buss-postcode');
        if (isValid) {
            isValid = CharLengthValidation('#business-postcode', 4, '#error-buss-postcodeCharLength');
        }
        if (isValid) {
            isValid = PostcodeValidation('#business-postcode', '#error-buss-postcode');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#business-postcode', '#error-buss-postcodeInvalidChar');
        }
        $("#business-postcode-hidden").val($("#business-postcode").val());
        return isValid;
    }
    return true;
}
ValidateBusinessSuburb = function () {
    $("#error-buss-suburb, #error-buss-suburbCharLength, #error-buss-suburbInvalidChar").hide();

    if ($("#post-diff:checked").length > 0) {
        var isValid = true;
        isValid = RequiredFieldValidation('#business-suburb', '#error-buss-suburb');
        if (isValid) {
            isValid = CharLengthValidation('#business-suburb', 50, '#error-buss-suburbCharLength');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#business-suburb', '#error-buss-suburbInvalidChar');
        }
        $("#business-suburb-hidden").val($("#business-suburb").val());
        return isValid;
    }
    return true;
}
ValidateClosestBranch = function () {
    $("#error-branch-search, #error-branch-searchCharLength, #error-branch-searchInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#branch-search', '#error-branch-search');
    if (isValid) {
        isValid = CharLengthValidation('#branch-search', 100, '#error-branch-searchCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation_MiddysBranchSearch('#branch-search', '#error-branch-searchInvalidChar');
    }
    if (isValid)
        isValid = IsClosestBranchSelected();
    return isValid;
}
ValidateBusinessType = function () {
    $("#error-business-type, #error-business-typeCharLength, #error-business-typeInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#company_business_type', '#error-business-type');
    if (isValid) {
        isValid = CharLengthValidation('#company_business_type', 100, '#error-business-typeCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#company_business_type', '#error-business-typeInvalidChar');
    }
    return isValid;
}

ValidateJobManagementSoftware = function () {
    $("#error-company-preferred-jms, #error-company-preferred-jmsCharLength, #error-company-preferred-jmsInvalidChar").hide();

    return RequiredFieldValidation('#company_preferred_jms', '#error-company-preferred-jms') &&
            CharLengthValidation('#company_preferred_jms', 100, '#error-company-preferred-jmsCharLength') &&
            InvalidCharValidation('#company_preferred_jms', '#error-company-preferred-jmsInvalidChar');
}

ValidateOtherSoftware = function () {
    $("#error-other-software, #error-other-softwareCharLength, #error-other-softwareInvalidChar").hide();

    const softwareValue = document.getElementById('company_preferred_jms').value;
    
    if(softwareValue == 'Other') {
        return RequiredFieldValidation('#other_software', '#error-other-software') &&
            CharLengthValidation('#other_software', 100, '#error-other-softwareCharLength') &&
            InvalidCharValidation('#other_software', '#error-other-softwareInvalidChar');
    }
    return true;
}
ValidateCompanyACN = function () {
    $("#error-company-acn, #error-company-acnCharLength, #error-company-acnInvalidChar").hide();

    if ($("#company-acn").length > 0) {
        var isValid = true;
        isValid = ValidateACN('#company-acn', '#error-company-acn', false);
        if (isValid) {
            isValid = CharLengthValidation('#company-acn', 100, '#error-company-acnCharLength');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#company-acn', '#error-company-acnInvalidChar');
        }
        return isValid;
    }
    return true;
}
ValidateTrusteeName = function () {
    $("#error-trustee-name, #error-trustee-nameCharLength, #error-trustee-nameInvalidChar").hide();

    if ($("#trustee-name").length > 0) {
        var isValid = true;
        isValid = RequiredFieldValidation('#trustee-name', '#error-trustee-name');
        if (isValid) {
            isValid = CharLengthValidation('#trustee-name', 50, '#error-trustee-nameCharLength');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#trustee-name', '#error-trustee-nameInvalidChar');
        }
        return isValid;
    }
    return true;
}
ValidateTrusteeACN = function () {
    $("#error-acn, #error-acnCharLength, #error-acnInvalidChar").hide();

    if ($("#acn").length > 0) {
        var isValid = true;
        isValid = ValidateACN('#acn', '#error-acn', true);
        if (isValid) {
            isValid = CharLengthValidation('#acn', 100, '#error-acnCharLength');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#acn', '#error-acnInvalidChar');
        }
        return isValid;
    }
    return true;
}
ValidateBusinessYears = function () {
    $("#error-business-years, #error-business-yearsCharLength, #error-business-yearsInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#business-years', '#error-business-years');
    if (isValid) {
        isValid = CharLengthValidation('#business-years', 3, '#error-business-yearsCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#business-years', '#error-business-yearsInvalidChar');
    }
    return isValid;
}
ValidateCompanyABN = function () {
    var abnNum = $("#abn").val();
    if (abnNum == "" || abnNum == null || abnNum == undefined) {
        $("#abn").addClass("field-error");
        $("#error-company-abn").text('ABN is required');
        $("#error-company-abn").show();
    }
    else {
        abnNum = abnNum.replace(/ /g, ''); // strip spaces
        //0. ABN must be 11 digits long
        if (abnNum.length != 11 || isNaN(parseInt(abnNum))) {
            $("#abn").addClass("field-error");
            $("#error-company-abn").text('ABN is required');
            $("#error-company-abn").show();
        }
        else {
            if (IsValidAbn(abnNum)) {
                $("#abn").removeClass("field-error");
                $("#error-company-abn").text('');
                $("#error-company-abn").hide();
                return true;
            }
            else {
                $("#abn").addClass("field-error");
                $("#error-company-abn").text('ABN is required');
                $("#error-company-abn").show();
            }
        }
    }
    return false;
}

ValidateRECLicenseNumber = function () {
    $("#error-rec-CharLength, #error-rec-InvalidChar").hide();

    var isValid = true;
    var value = document.getElementById('Suburb');
    if (value !== null && value !== "") {
        if (isValid) {
            isValid = CharLengthValidation('#Suburb', 20, '#error-rec-CharLength');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#Suburb', '#error-rec-InvalidChar');
        }
    }
    return isValid;
}

ValidateACN = function (fieldID, fieldClass, isTrusteeACN) {
    var acnNum = $(fieldID).val(); var acnRegex = /^(\s*\d\s*){9}$/;
    if (acnNum == "" || acnNum == null || acnNum == undefined) {
        $(fieldID).addClass("field-error");
        $(fieldClass).text(isTrusteeACN ? 'Trustee ACN is required' : 'ACN is required');
        $(fieldClass).show();
        return false;
    }
    else {
        if (!acnRegex.test(acnNum)) {
            $(fieldID).addClass("field-error");
            $(fieldClass).text(isTrusteeACN ? 'Trustee ACN is required' : 'ACN is required');
            $(fieldClass).show();
            return false;
        }
        else if (!IsValidACN(acnNum)) {
            $(fieldID).addClass("field-error");
            $(fieldClass).text(isTrusteeACN ? 'Valid Trustee ACN is required' : 'Valid ACN is required'); 
            $(fieldClass).show();
            return false;
        }
        else {
            $(fieldID).removeClass("field-error");
            $(fieldClass).text('');
            $(fieldClass).hide();
            return true;
        }
    }
}
ValidateBankName = function () {
    $("#error-company-bank, #error-company-bankCharLength, #error-company-bankInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#company-bank', '#error-company-bank');
    if (isValid) {
        isValid = CharLengthValidation('#company-bank', 100, '#error-company-bankCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#company-bank', '#error-company-bankInvalidChar');
    }
    return isValid;
}
ValidateBSB = function () {
    var bsbNo = $('#bank-bsb').val(); bsbRegex = /^\d{3}-?\d{3}$/;
    if (bsbNo == "" || bsbNo == null || bsbNo == undefined) {
        $('#bank-bsb').addClass("field-error");
        $('#error-bank-bsb').text('BSB is required');
        $('#error-bank-bsb').show();
        return false;
    }
    else if (!bsbRegex.test(bsbNo)) {
        $('#bank-bsb').addClass("field-error");
        $('#error-bank-bsb').text('Valid BSB is required');
        $('#error-bank-bsb').show();
        return false;
    }
    else {
        $('#bank-bsb').removeClass("field-error");
        $('#error-bank-bsb').hide();
        return true;
    }
}
ValidateAccountNo = function () {
    var accNo = $('#bank-account').val(); accountNoRegex = /^[\d]{5,10}$/;
    if (accNo == "" || accNo == null || accNo == undefined) {
        $('#bank-account').addClass("field-error");
        $('#error-bank-account').text('Account Number is required');/*Please enter your account number');*/
        $('#error-bank-account').show();
        return false;
    }
    else if (!accountNoRegex.test(accNo)) {
        $('#bank-account').addClass("field-error");
        $('#error-bank-account').text('Valid bank account number is required');
        $('#error-bank-account').show();
        return false;
    }
    else {
        $('#bank-account').removeClass("field-error");
        $('#error-bank-account').hide();
        return true;
    }
}
RequiredFieldValidation = function (fieldClass, errorClass) {
    var fieldData = $(fieldClass).val();
    if (fieldData == "" || fieldData == null || fieldData == undefined) {
        $(fieldClass).addClass("field-error");
        $(errorClass).show();
        return false;
    }
    else {
        $(fieldClass).removeClass("field-error");
        $(errorClass).hide();
        return true;
    }
}

PostcodeValidation = function (fieldClass, errorClass) {
    if (!ValidatePostcode_Common(fieldClass)) {
        $(fieldClass).addClass("field-error");
        $(errorClass).show();
        return false;
    }
    else {
        $(fieldClass).removeClass("field-error");
        $(errorClass).hide();
        return true;
    }
}

CharLengthValidation = function (fieldClass, maxLength, errorClass) {
    var fieldData = $(fieldClass).val();
    if (fieldData.length > maxLength) {
        $(fieldClass).addClass("field-error");
        $(errorClass).show();
        return false;
    }
    else {
        $(fieldClass).removeClass("field-error");
        $(errorClass).hide();
        return true;
    }
}

InvalidCharValidation = function (fieldClass, errorClass, isEmail = false) {
    var fieldData = $(fieldClass).val();
    if (!IsInputSecure(fieldData, isEmail)) {
        $(fieldClass).addClass("field-error");
        $(errorClass).show();
        return false;
    }
    else {
        $(fieldClass).removeClass("field-error");
        $(errorClass).hide();
        return true;
    }
}

InvalidNameCharValidation = function (fieldClass, errorClass) {
    var fieldData = $(fieldClass).val();
    if (!IsInputNameValid(fieldData)) {
        $(fieldClass).addClass("field-error");
        $(errorClass).show();
        return false;
    }
    else {
        $(fieldClass).removeClass("field-error");
        $(errorClass).hide();
        return true;
    }
}

InvalidCharValidation_MiddysBranchSearch = function (fieldClass, errorClass) {
    var fieldData = $(fieldClass).val();
    if (!IsInputSecure_MiddysBranchSearch(fieldData)) {
        $(fieldClass).addClass("field-error");
        $(errorClass).show();
        return false;
    }
    else {
        $(fieldClass).removeClass("field-error");
        $(errorClass).hide();
        return true;
    }
}

InvalidCharValidation_Date = function (fieldClass, errorClass) {
    var fieldData = $(fieldClass).val();
    if (!IsInputSecureDate(fieldData)) {
        $(fieldClass).addClass("field-error");
        $(errorClass).show();
        return false;
    }
    else {
        $(fieldClass).removeClass("field-error");
        $(errorClass).hide();
        return true;
    }
}

function IsValidAbn(abn) { //51 824 753 556
    // abn = abn.replace(/ /g, ''); // strip spaces

    weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    weightedSum = 0;
    //Rules: 1,2,3  
    $.each(weight, function (i, val) {
        // console.log(abn[i]);
        weightedSum += (parseInt(abn[i]) - (i == 0 ? 1 : 0)) * weight[i];
    });
    //Rules: 4,5                 
    return (weightedSum % 89) == 0;
}

var IsCompanyFormValid = function () {
    var isValid = true;
    if (!ValidateLegalName())
        isValid = false;
    if (!ValidateTradingName())
        isValid = false;
    if (!ValidateAddress())
        isValid = false;
    if (!ValidatePostcode())
        isValid = false;
    if (!ValidateSuburb())
        isValid = false;
    if (!ValidateBusinessAddress())
        isValid = false;
    if (!ValidateBusinessPostcode())
        isValid = false;
    if (!ValidateBusinessSuburb())
        isValid = false;
    if (!ValidateClosestBranch())
        isValid = false;
    if (!ValidateBusinessType())
        isValid = false;
    if (!ValidateCompanyACN())
        isValid = false;
    if (!ValidateTrusteeName())
        isValid = false;
    if (!ValidateTrusteeACN())
        isValid = false;
    if (!ValidateBusinessYears())
        isValid = false
    if (!ValidateCompanyABN())
        isValid = false
    if (!ValidateRECLicenseNumber())
        isValid = false
    if (!ValidateBankName())
        isValid = false;
    if (!ValidateBSB())
        isValid = false
    if (!ValidateAccountNo())
        isValid = false
    if (!ValidateJobManagementSoftware())
        isValid = false;
    if (!ValidateOtherSoftware())
        isValid = false
    return isValid;
}


ValidatePerson1Fname = function () {
    $("#error-management-fname, #error-management-fnameCharLength, #error-management-fnameInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#management-fname', '#error-management-fname');
    if (isValid) {
        isValid = CharLengthValidation('#management-fname', 50, '#error-management-fnameCharLength');
    }
    if (isValid) {
        isValid = InvalidNameCharValidation('#management-fname', '#error-management-fnameInvalidChar');
    }
    return isValid;
}
ValidatePerson1Lname = function () {
    $("#error-management-lname, #error-management-lnameCharLength, #error-management-lnameInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#management-lname', '#error-management-lname');
    if (isValid) {
        isValid = CharLengthValidation('#management-lname', 50, '#error-management-lnameCharLength');
    }
    if (isValid) {
        isValid = InvalidNameCharValidation('#management-lname', '#error-management-lnameInvalidChar');
    }
    return isValid;
}
ValidatePerson1DOB = function () {
    $("#error-birthdate, #error-birthdateCharLength, #error-birthdateInvalidChar").hide();

    var isValid = true;
    isValid = ValidateDOB('#birthdate', '#error-birthdate');
    if (isValid) {
        isValid = CharLengthValidation('#birthdate', 10, '#error-birthdateCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation_Date('#birthdate', '#error-birthdateInvalidChar');
    }
    return isValid;
}
ValidatePerson1License = function () {
    $("#error-driver-license, #error-driver-licenseCharLength, #error-driver-licenseInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#driver-license', '#error-driver-license');
    if (isValid) {
        isValid = CharLengthValidation('#driver-license', 20, '#error-driver-licenseCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#driver-license', '#error-driver-licenseInvalidChar');
    }
    return isValid;
}
ValidatePerson1Address = function () {
    $("#error-management-add, #error-management-addCharLength, #error-management-addInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#management-add', '#error-management-add');
    if (isValid) {
        isValid = CharLengthValidation('#management-add', 100, '#error-management-addCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation_MiddysBranchSearch('#management-add', '#error-management-addInvalidChar');
    }
    return isValid;
}
ValidatePerson1Postcode = function () {
    $("#error-man-postcode, #error-man-postcodeCharLength, #error-man-postcodeInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#man-postcode', '#error-man-postcode');
    if (isValid) {
        isValid = CharLengthValidation('#man-postcode', 4, '#error-man-postcodeCharLength');
    }
    if (isValid) {
        isValid = PostcodeValidation('#man-postcode', '#error-man-postcode');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#man-postcode', '#error-man-postcodeInvalidChar');
    }
    $("#man-postcode-hidden").val($("#man-postcode").val());
    return isValid;
}
ValidatePerson1Suburb = function () {
    $("#error-man-suburb, #error-man-suburbCharLength, #error-man-suburbInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#man-suburb', '#error-man-suburb');
    if (isValid) {
        isValid = CharLengthValidation('#man-suburb', 50, '#error-man-suburbCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#man-suburb', '#error-man-suburbInvalidChar');
    }
    $("#man-suburb-hidden").val($("#man-suburb").val());
    return isValid;
}
ValidatePerson2Fname = function () {
    $("#error-management-first-name1, #error-management-first-nameCharLength1, #error-management-first-nameInvalidChar1").hide();

    var isValid = true;
    if ($("#management-first-name1").length > 0) {
        isValid = RequiredFieldValidation('#management-first-name1', '#error-management-first-name1');
        if (isValid) {
            isValid = CharLengthValidation('#management-first-name1', 50, '#error-management-first-nameCharLength1');
        }
        if (isValid) {
            isValid = InvalidNameCharValidation('#management-first-name1', '#error-management-first-nameInvalidChar1');
        }
    }
    return isValid;
}
ValidatePerson2Lname = function () {
    $("#error-management-last-name1, #error-management-last-nameCharLength1, #error-management-last-nameInvalidChar1").hide();

    var isValid = true;
    if ($("#management-last-name1").length > 0) {
        isValid = RequiredFieldValidation('#management-last-name1', '#error-management-last-name1');
        if (isValid) {
            isValid = CharLengthValidation('#management-last-name1', 50, '#error-management-last-nameCharLength1');
        }
        if (isValid) {
            isValid = InvalidNameCharValidation('#management-last-name1', '#error-management-last-nameInvalidChar1');
        }
    }
    return isValid;
}
ValidatePerson2DOB = function () {
    $("#error-management-birth-date1, #error-management-birth-dateCharLength1, #error-management-birth-dateInvalidChar1").hide();

    var isValid = true;
    if ($("#management-birth-date1").length > 0) {
        isValid = ValidateDOB('#management-birth-date1', '#error-management-birth-date1');
        if (isValid) {
            isValid = CharLengthValidation('#management-birth-date1', 10, '#error-management-birth-dateCharLength1');
        }
        if (isValid) {
            isValid = InvalidCharValidation_Date('#management-birth-date1', '#error-management-birth-dateInvalidChar1');
        }
    }
    return isValid;
}
ValidatePerson2License = function () {
    $("#error-management-drivers-licence1, #error-management-drivers-licenceCharLength1, #error-management-drivers-licenceInvalidChar1").hide();

    var isValid = true;
    if ($("#management-drivers-licence1").length > 0) {
        isValid = RequiredFieldValidation('#management-drivers-licence1', '#error-management-drivers-licence1');
        if (isValid) {
            isValid = CharLengthValidation('#management-drivers-licence1', 20, '#error-management-drivers-licenceCharLength1');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#management-drivers-licence1', '#error-management-drivers-licenceInvalidChar1');
        }
    }
    return isValid;
}
ValidatePerson2Address = function () {
    $("#error-management-add1, #error-management-addCharLength1, #error-management-addInvalidChar1").hide();

    var isValid = true;
    if ($("#management-add1").length > 0) {
        isValid = RequiredFieldValidation('#management-add1', '#error-management-add1');
        if (isValid) {
            isValid = CharLengthValidation('#management-add1', 100, '#error-management-addCharLength1');
        }
        if (isValid) {
            isValid = InvalidCharValidation_MiddysBranchSearch('#management-add1', '#error-management-addInvalidChar1');
        }
    }
    return isValid;
}
ValidatePerson2Postcode = function () {
    $("#error-management-postcode1, #error-management-postcodeCharLength1, #error-management-postcodeInvalidChar1").hide();

    var isValid = true;
    if ($("#management-postcode1").length > 0) {
        isValid = RequiredFieldValidation('#management-postcode1', '#error-management-postcode1');
        if (isValid) {
            isValid = CharLengthValidation('#management-postcode1', 4, '#error-management-postcodeCharLength1');
        }
        if (isValid) {
            isValid = PostcodeValidation('#management-postcode1', '#error-management-postcode1');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#management-postcode1', '#error-management-postcodeInvalidChar1');
        }
        $("#management-postcode1-hidden").val($("#management-postcode1").val());
    }
    return isValid;
}
ValidatePerson2Suburb = function () {
    $("#error-management-suburb1, #error-management-suburbCharLength1, #error-management-suburbInvalidChar1").hide();

    var isValid = true;
    if ($("#management-suburb1").length > 0) {
        isValid = RequiredFieldValidation('#management-suburb1', '#error-management-suburb1');
        if (isValid) {
            isValid = CharLengthValidation('#management-suburb1', 50, '#error-management-suburbCharLength1');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#management-suburb1', '#error-management-suburbInvalidChar1');
        }
        $("#management-suburb1-hidden").val($("#management-suburb1").val());
    }
    return isValid;
}
ValidatePerson3Fname = function () {
    $("#error-management-first-name2, #error-management-first-nameCharLength2, #error-management-first-nameInvalidChar2").hide();

    var isValid = true;
    if ($("#management-first-name2").length > 0) {
        isValid = RequiredFieldValidation('#management-first-name2', '#error-management-first-name2');
        if (isValid) {
            isValid = CharLengthValidation('#management-first-name2', 50, '#error-management-first-nameCharLength2');
        }
        if (isValid) {
            isValid = InvalidNameCharValidation('#management-first-name2', '#error-management-first-nameInvalidChar2');
        }
    }
    return isValid;
}
ValidatePerson3Lname = function () {
    $("#error-management-last-name2, #error-management-last-nameCharLength2, #error-management-last-nameInvalidChar2").hide();

    var isValid = true;
    if ($("#management-last-name2").length > 0) {
        isValid = RequiredFieldValidation('#management-last-name2', '#error-management-last-name2');
        if (isValid) {
            isValid = CharLengthValidation('#management-last-name2', 50, '#error-management-last-nameCharLength2');
        }
        if (isValid) {
            isValid = InvalidNameCharValidation('#management-last-name2', '#error-management-last-nameInvalidChar2');
        }
    }
    return isValid;
}
ValidatePerson3DOB = function () {
    $("#error-management-birth-date2, #error-management-birth-dateCharLength2, #error-management-birth-dateInvalidChar2").hide();

    var isValid = true;
    if ($("#management-birth-date2").length > 0) {
        isValid = ValidateDOB('#management-birth-date2', '#error-management-birth-date2');
        if (isValid) {
            isValid = CharLengthValidation('#management-birth-date2', 10, '#error-management-birth-dateCharLength2');
        }
        if (isValid) {
            isValid = InvalidCharValidation_Date('#management-birth-date2', '#error-management-birth-dateInvalidChar2');
        }
    }
    return isValid;
}
ValidatePerson3License = function () {
    $("#error-management-drivers-licence2, #error-management-drivers-licenceCharLength2, #error-management-drivers-licenceInvalidChar2").hide();

    var isValid = true;
    if ($("#management-drivers-licence2").length > 0) {
        isValid = RequiredFieldValidation('#management-drivers-licence2', '#error-management-drivers-licence2');
        if (isValid) {
            isValid = CharLengthValidation('#management-drivers-licence2', 20, '#error-management-drivers-licenceCharLength2');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#management-drivers-licence2', '#error-management-drivers-licenceInvalidChar2');
        }
    }
    return isValid;
}
ValidatePerson3Address = function () {
    $("#error-management-add2, #error-management-addCharLength2, #error-management-addInvalidChar2").hide();

    var isValid = true;
    if ($("#management-add2").length > 0) {
        isValid = RequiredFieldValidation('#management-add2', '#error-management-add2');
        if (isValid) {
            isValid = CharLengthValidation('#management-add2', 100, '#error-management-addCharLength2');
        }
        if (isValid) {
            isValid = InvalidCharValidation_MiddysBranchSearch('#management-add2', '#error-management-addInvalidChar2');
        }
    }
    return isValid;
}
ValidatePerson3Postcode = function () {
    $("#error-management-postcode2, #error-management-postcodeCharLength2, #error-management-postcodeInvalidChar2").hide();

    var isValid = true;
    if ($("#management-postcode2").length > 0) {
        isValid = RequiredFieldValidation('#management-postcode2', '#error-management-postcode2');
        if (isValid) {
            isValid = CharLengthValidation('#management-postcode2', 4, '#error-management-postcodeCharLength2');
        }
        if (isValid) {
            isValid = PostcodeValidation('#management-postcode2', '#error-management-postcode2');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#management-postcode2', '#error-management-postcodeInvalidChar2');
        }
        $("#management-postcode2-hidden").val($("#management-postcode2").val());
    }
    return isValid;
}
ValidatePerson3Suburb = function () {
    $("#error-management-suburb2, #error-management-suburbCharLength2, #error-management-suburbInvalidChar2").hide();

    var isValid = true;
    if ($("#management-suburb2").length > 0) {
        isValid = RequiredFieldValidation('#management-suburb2', '#error-management-suburb2');
        if (isValid) {
            isValid = CharLengthValidation('#management-suburb2', 50, '#error-management-suburbCharLength2');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#management-suburb2', '#error-management-suburbInvalidChar2');
        }
        $("#management-suburb2-hidden").val($("#management-suburb2").val());
    }
    return isValid;
}
ValidateDOB = function (fieldClass, errorClass) {
    var fieldData = $(fieldClass).val();
    if (fieldData == "" || fieldData == null || fieldData == undefined) {
        $(fieldClass).addClass("field-error");
        $(errorClass).text('Date of Birth is required');
        $(errorClass).show();
        return false;
    }
    else {
        var age = getAge(fieldData);
        if (age < 18) {
            $(fieldClass).addClass("field-error");
            $(errorClass).text('A person must be over 18');/*Age must be 18 or above');*/
            $(errorClass).show();
            return false;
        }
        else {
            $(fieldClass).removeClass("field-error");
            $(errorClass).text('');
            $(errorClass).hide();
            return true;
        }
    }
}
function getAge(DOB) {
    var today = new Date();
    var birthDate = new Date(DOB);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}
var IsManagementFormValid = function () {
    var isValid = true;
    if (!ValidatePerson1Fname())
        isValid = false;
    if (!ValidatePerson1Lname())
        isValid = false
    if (!ValidatePerson1DOB())
        isValid = false
    if (!ValidatePerson1License())
        isValid = false
    if (!ValidatePerson1Address())
        isValid = false;
    if (!ValidatePerson1Postcode())
        isValid = false
    if (!ValidatePerson1Suburb())
        isValid = false
    if (!ValidatePerson2Fname())
        isValid = false;
    if (!ValidatePerson2Lname())
        isValid = false
    if (!ValidatePerson2DOB())
        isValid = false
    if (!ValidatePerson2License())
        isValid = false
    if (!ValidatePerson2Address())
        isValid = false;
    if (!ValidatePerson2Postcode())
        isValid = false
    if (!ValidatePerson2Suburb())
        isValid = false
    if (!ValidatePerson3Fname())
        isValid = false;
    if (!ValidatePerson3Lname())
        isValid = false
    if (!ValidatePerson3DOB())
        isValid = false
    if (!ValidatePerson3License())
        isValid = false
    if (!ValidatePerson3Address())
        isValid = false;
    if (!ValidatePerson3Postcode())
        isValid = false
    if (!ValidatePerson3Suburb())
        isValid = false
    return isValid;
}

ValidateCompany1Name = function () {
    $("#error-company-name, #error-company-nameCharLength, #error-company-nameInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#company-name', '#error-company-name');
    if (isValid) {
        isValid = CharLengthValidation('#company-name', 50, '#error-company-nameCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#company-name', '#error-company-nameInvalidChar');
    }
    return isValid;
}
ValidateCompany1Fname = function () {
    $("#error-reference-fname, #error-reference-fnameCharLength, #error-reference-fnameInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#reference-fname', '#error-reference-fname');
    if (isValid) {
        isValid = CharLengthValidation('#reference-fname', 50, '#error-reference-fnameCharLength');
    }
    if (isValid) {
        isValid = InvalidNameCharValidation('#reference-fname', '#error-reference-fnameInvalidChar');
    }
    return isValid;
}
ValidateCompany1Lname = function () {
    $("#error-reference-lname, #error-reference-lnameCharLength, #error-reference-lnameInvalidChar").hide();

    var isValid = true;
    isValid = RequiredFieldValidation('#reference-lname', '#error-reference-lname');
    if (isValid) {
        isValid = CharLengthValidation('#reference-lname', 50, '#error-reference-lnameCharLength');
    }
    if (isValid) {
        isValid = InvalidNameCharValidation('#reference-lname', '#error-reference-lnameInvalidChar');
    }
    return isValid;
}
ValidateCompany1Mobile = function () {
    $("#error-reference-contact, #error-reference-contactCharLength, #error-reference-contactInvalidChar").hide();

    var isValid = true;
    isValid = CharLengthValidation('#reference-contact', 15, '#error-reference-contactCharLength');
    if (isValid) {
        isValid = ValidateMobile('#reference-contact', '#error-reference-contact');
    }
    return isValid;
}
ValidateCompany1Email = function () {
    $("#error-reference-email, #error-reference-emailCharLength, #error-reference-emailInvalidChar").hide();

    var isValid = true;
    isValid = ValidateEmail('#reference-email', '#error-reference-email');
    if (isValid) {
        isValid = CharLengthValidation('#reference-email', 60, '#error-reference-emailCharLength');
    }
    if (isValid) {
        isValid = InvalidCharValidation('#reference-email', '#error-reference-emailInvalidChar', true);
    }
    return isValid;
}
ValidateCompany2Name = function () {
    $("#error-company-name1, #error-company-nameCharLength1, #error-company-nameInvalidChar1").hide();

    var isValid = true;
    if ($("#company-name1").length > 0) {
        isValid = RequiredFieldValidation('#company-name1', '#error-company-name1');
        if (isValid) {
            isValid = CharLengthValidation('#company-name1', 50, '#error-company-nameCharLength1');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#company-name1', '#error-company-nameInvalidChar1');
        }
    }
    return isValid;
}
ValidateCompany2Fname = function () {
    $("#error-company-first-name1, #error-company-first-nameCharLength1, #error-company-first-nameInvalidChar1").hide();

    var isValid = true;
    if ($("#company-first-name1").length > 0) {
        isValid = RequiredFieldValidation('#company-first-name1', '#error-company-first-name1');
        if (isValid) {
            isValid = CharLengthValidation('#company-first-name1', 50, '#error-company-first-nameCharLength1');
        }
        if (isValid) {
            isValid = InvalidNameCharValidation('#company-first-name1', '#error-company-first-nameInvalidChar1');
        }
    }
    return isValid;
}
ValidateCompany2Lname = function () {
    $("#error-company-last-name1, #error-company-last-nameCharLength1, #error-company-last-nameInvalidChar1").hide();

    var isValid = true;
    if ($("#company-last-name1").length > 0) {
        isValid = RequiredFieldValidation('#company-last-name1', '#error-company-last-name1');
        if (isValid) {
            isValid = CharLengthValidation('#company-last-name1', 50, '#error-company-last-nameCharLength1');
        }
        if (isValid) {
            isValid = InvalidNameCharValidation('#company-last-name1', '#error-company-last-nameInvalidChar1');
        }
    }
    return isValid;
}
ValidateCompany2Mobile = function () {
    $("#error-company-number1, #error-company-numberCharLength1, #error-company-numberInvalidChar1").hide();

    var isValid = true;
    if ($("#company-number1").length > 0) {
        isValid = CharLengthValidation('#company-number1', 15, '#error-company-numberCharLength1');
        if (isValid) {
            isValid = ValidateMobile('#company-number1', '#error-company-number1');
        }
    }
    return isValid;
}
ValidateCompany2Email = function () {
    $("#error-company-email1, #error-company-emailCharLength1, #error-company-emailInvalidChar1").hide();

    var isValid = true;
    if ($("#company-email1").length > 0) {
        isValid = ValidateEmail('#company-email1', '#error-company-email1');
        if (isValid) {
            isValid = CharLengthValidation('#company-email1', 60, '#error-company-emailCharLength1');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#company-email1', '#error-company-emailInvalidChar1', true);
        }
    }
    return isValid;
}
ValidateCompany3Name = function () {
    $("#error-company-name2, #error-company-nameCharLength2, #error-company-nameInvalidChar2").hide();

    var isValid = true;
    if ($("#company-name2").length > 0) {
        isValid = RequiredFieldValidation('#company-name2', '#error-company-name2');
        if (isValid) {
            isValid = CharLengthValidation('#company-name2', 50, '#error-company-nameCharLength2');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#company-name2', '#error-company-nameInvalidChar2');
        }
    }
    return isValid;
}
ValidateCompany3Fname = function () {
    $("#error-company-first-name2, #error-company-first-nameCharLength2, #error-company-first-nameInvalidChar2").hide();

    var isValid = true;
    if ($("#company-first-name2").length > 0) {
        isValid = RequiredFieldValidation('#company-first-name2', '#error-company-first-name2');
        if (isValid) {
            isValid = CharLengthValidation('#company-first-name2', 50, '#error-company-first-nameCharLength2');
        }
        if (isValid) {
            isValid = InvalidNameCharValidation('#company-first-name2', '#error-company-first-nameInvalidChar2');
        }
    }

    return isValid;
}
ValidateCompany3Lname = function () {
    $("#error-company-last-name2, #error-company-last-nameCharLength2, #error-company-last-nameInvalidChar2").hide();

    var isValid = true;
    if ($("#company-last-name2").length > 0) {
        isValid = RequiredFieldValidation('#company-last-name2', '#error-company-last-name2');
        if (isValid) {
            isValid = CharLengthValidation('#company-last-name2', 50, '#error-company-last-nameCharLength2');
        }
        if (isValid) {
            isValid = InvalidNameCharValidation('#company-last-name2', '#error-company-last-nameInvalidChar2');
        }
    }
    return isValid;
}
ValidateCompany3Mobile = function () {
    $("#error-company-number2, #error-company-numberCharLength2, #error-company-numberInvalidChar2").hide();

    var isValid = true;
    if ($("#company-number2").length > 0) {
        isValid = CharLengthValidation('#company-number2', 15, '#error-company-numberCharLength2');
        if (isValid) {
            isValid = ValidateMobile('#company-number2', '#error-company-number2');
        }
    }
    return isValid;
}
ValidateCompany3Email = function () {
    $("#error-company-email2, #error-company-emailCharLength2, #error-company-emailInvalidChar2").hide();

    var isValid = true;
    if ($("#company-email2").length > 0) {
        isValid = ValidateEmail('#company-email2', '#error-company-email2');
        if (isValid) {
            isValid = CharLengthValidation('#company-email2', 60, '#error-company-emailCharLength2');
        }
        if (isValid) {
            isValid = InvalidCharValidation('#company-number2', '#error-company-emailInvalidChar2', true);
        }
    }
    return isValid;
}
ValidateTerms = function () {
    if ($("#terms-conditions:checked").length > 0) {
        $("#terms-conditions").removeClass("field-error");
        $("#error-terms-conditions").hide();
        return true;
    }
    else {
        $("#terms-conditions").addClass("field-error");
        $("#error-terms-conditions").show();
        return false;
    }
}
ValidateMobile = function (fieldId, fieldError) {
    var phone = $(fieldId).val();
    if (!phone) {
        $(fieldId).addClass("field-error");
        $(fieldError).text("Contact number is required");
        $(fieldError).show();
        return false;
    }
    else if (!ValidatePhoneRegex(phone)) {
        $(fieldId).addClass("field-error");
        $(fieldError).text("Contact number is required");
        $(fieldError).show();
        return false;
    }
    else {
        $(fieldId).removeClass("field-error");
        $(fieldError).text("");
        $(fieldError).hide();
        return true;
    }
}
var IsTradeFormValid = function () {
    var isValid = true;
    if (!ValidateCompany1Name())
        isValid = false;
    if (!ValidateCompany1Fname())
        isValid = false
    if (!ValidateCompany1Lname())
        isValid = false
    if (!ValidateCompany1Mobile())
        isValid = false
    if (!ValidateCompany1Email())
        isValid = false
    if (!ValidateCompany2Name())
        isValid = false;
    if (!ValidateCompany2Fname())
        isValid = false
    if (!ValidateCompany2Lname())
        isValid = false
    if (!ValidateCompany2Mobile())
        isValid = false
    if (!ValidateCompany2Email())
        isValid = false
    if (!ValidateCompany3Name())
        isValid = false;
    if (!ValidateCompany3Fname())
        isValid = false
    if (!ValidateCompany3Lname())
        isValid = false
    if (!ValidateCompany3Mobile())
        isValid = false
    if (!ValidateCompany3Email())
        isValid = false
    if (!ValidateTerms())
        isValid = false
    return isValid;
}
IsClosestBranchSelected = function () {
    if ($("#branch-selected .branch-data").length == 0) {
        $("#branch-search").addClass("field-error");
        $("#error-branch-search").show();
        return false;
    }
    else {
        $("#branch-search").removeClass("field-error");
        $("#error-branch-search").hide();
        return true;
    }
}
